import styled from 'styled-components';
import { donedealBreakpoints } from 'styled-system';

const FreeHistoryCheckPanelContainer = styled.div<{
  displayTrustedDealerPanel: boolean;
}>`
  position: relative;
  background-color: ${({ theme }) => theme.donedeal.colors.GREEN_LIGHTEST};
  border-radius: ${({ theme }) => theme.donedeal.borderRadius.default};
  padding: ${({ theme }) =>
    `${theme.donedeal.spacing.M24} ${theme.donedeal.spacing.M16} ${theme.donedeal.spacing.M16}`};
  margin-top: ${({ theme, displayTrustedDealerPanel }) =>
    displayTrustedDealerPanel ? theme.donedeal.spacing.M32 : 0};
`;

const FreeBadge = styled.div`
  position: absolute;
  top: -${({ theme }) => theme.donedeal.spacing.S8};
  left: ${({ theme }) => theme.donedeal.spacing.M16};
  display: inline-flex;
  align-items: center;
  background: ${({ theme }) => theme.donedeal.colors.BLACK};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme }) => `0 ${theme.donedeal.spacing.S4}`};
`;

const Header = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.donedeal.spacing.M24};
`;

const Description = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.donedeal.spacing.S4};

  ${donedealBreakpoints.media.medium} {
    flex-direction: row;
    align-items: center;
  }
`;

const Icon = styled.img`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
`;

const ListContainer = styled.div`
  grid-template-columns: 1fr;
  display: grid;
  gap: ${({ theme }) => theme.donedeal.spacing.M16};
  margin-bottom: ${({ theme }) => theme.donedeal.spacing.M24};

  ${donedealBreakpoints.media.medium} {
    grid-template-columns: 1fr 1fr;
  }
`;

const NonVerifiedMessage = styled.div`
  ${({ theme }) => theme.donedeal.fontSize.M14};
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  border-radius: ${({ theme }) => theme.donedeal.borderRadius.default};
  padding: ${({ theme }) => theme.donedeal.spacing.S12};
  margin-bottom: ${({ theme }) => theme.donedeal.spacing.M24};
`;

export {
  FreeHistoryCheckPanelContainer,
  FreeBadge,
  Header,
  Description,
  Icon,
  ListContainer,
  NonVerifiedMessage,
};
